import { api } from "../client";

export const getMSServices = () => {
  return api.get(`/readytowork/microsoft`);
};
